// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function --experiment early-access-plugins-org-enrolled --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
// Note: The following attributes are automatically provided by the experiment provider
// and do not need to be passed as parameters: org_uuid
export const useEarlyAccessPluginsOrgEnrolledVariation = makeBooleanFlagValueHook('early-access-plugins-org-enrolled');
//# sourceMappingURL=useEarlyAccessPluginsOrgEnrolledVariation.js.map